import { useState } from "react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Flag } from "lucide-react";

const Who = ({ label, name }) => (
  <span className="truncate">{label}: {name ? <span className="text-slate-700 font-medium">{name}</span> : <span className="text-slate-300">Unassigned</span>}</span>
);

// Client · Assigned to (single owner)
export function CaseOwnership({ app, names, showClient = true, className = "" }) {
  const assignee = names[app.assigned_staff] || names[app.assigned_consultant];
  return (
    <div className={`flex flex-wrap gap-x-3 gap-y-0.5 text-xs text-slate-500 ${className}`} data-testid={`case-ownership-${app.id}`}>
      {showClient && <Who label="Client" name={app.client_name} />}
      <Who label="Assigned to" name={assignee} />
    </div>
  );
}

export const ImportantTag = () => (
  <span data-testid="case-important-tag" className="inline-flex items-center gap-1 text-[11px] font-bold text-rose-700 bg-rose-50 border border-rose-200 px-2 py-0.5 rounded-full"><Flag className="h-3 w-3 fill-rose-600 text-rose-600" /> Important</span>
);

export function ImportantToggle({ app, onChange, compact = false }) {
  const [busy, setBusy] = useState(false);
  const on = !!app.important;
  const toggle = async (e) => {
    e.preventDefault(); e.stopPropagation();
    setBusy(true);
    try { const { data } = await api.patch(`/applications/${app.id}/important`, { important: !on }); onChange(data.important); toast.success(data.important ? "Marked important" : "No longer important"); }
    catch (err) { toast.error(apiErr(err)); } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={`case-important-toggle-${app.id}`} onClick={toggle} disabled={busy} title={on ? "Remove Important flag" : "Mark as Important"}
      className={`inline-flex items-center gap-1.5 rounded-xl text-sm font-semibold disabled:opacity-60 ${compact ? "h-8 w-8 justify-center" : "px-3 py-2.5 border"} ${on ? "text-rose-600 border-rose-200 bg-rose-50" : "text-slate-400 border-slate-200 hover:text-rose-600"}`}>
      <Flag className={`h-4 w-4 ${on ? "fill-rose-600" : ""}`} />{!compact && (on ? "Important" : "Mark important")}
    </button>
  );
}

export function TaskImportantToggle({ task, onChange }) {
  const [busy, setBusy] = useState(false);
  const on = !!task.important;
  const toggle = async (e) => {
    e.preventDefault(); e.stopPropagation();
    setBusy(true);
    try { const { data } = await api.patch(`/tasks/${task.id}/important`, { important: !on }); onChange(data.important); }
    catch (err) { toast.error(apiErr(err)); } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={`task-important-toggle-${task.id}`} onClick={toggle} disabled={busy} title={on ? "Remove Important flag" : "Mark as Important"}
      className={`h-7 w-7 inline-flex items-center justify-center rounded-lg disabled:opacity-60 ${on ? "text-rose-600 bg-rose-50" : "text-slate-300 hover:text-rose-600"}`}>
      <Flag className={`h-3.5 w-3.5 ${on ? "fill-rose-600" : ""}`} />
    </button>
  );
}
